module.exports = __webpack_public_path__ + "static/media/search-line.3e8386c6.svg";